import { View } from 'react-native';

import { EventDetails } from '../../../RTK/api/events/types';
import { TableDetails } from '../../../RTK/api/reservations/types';
import { StoreDetails } from '../../../RTK/api/store/types';

export enum ReservationType {
  EVENT = 'event',
  DINING = 'dining',
}

export type ItemInfo =
  | (EventDetails & { type: ReservationType.EVENT })
  | (TableDetails & { type: ReservationType.DINING });

export type RenderProps = {
  filter: {
    date?: string;
    size: number;
    time?: string;
    type: string;
  };
  itemInfo: ItemInfo;
  storeInfo: StoreDetails;
  scrollToSelectTime: (ref: number | View) => void; // on mobile, yposition (number). on web, View ref
};

export type SheetProps = {
  payload: RenderProps;
};
